/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AttachmentResponseDTO,
  ProblemDetails,
  ReportResponseDTO,
} from '../models/index';
import {
    AttachmentResponseDTOFromJSON,
    AttachmentResponseDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ReportResponseDTOFromJSON,
    ReportResponseDTOToJSON,
} from '../models/index';

export interface DeleteByIdRequest {
    idFileAllegato?: number;
}

export interface GetAttachmentByIdRequest {
    idFileAllegato: number;
}

export interface UploadFileTemporaneoRequest {
    file?: Blob;
}

/**
 * 
 */
export class AllegatiTemporaneiApi extends runtime.BaseAPI {

    /**
     */
    async deleteByIdRaw(requestParameters: DeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['idFileAllegato'] != null) {
            queryParameters['idFileAllegato'] = requestParameters['idFileAllegato'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Attachments`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteById(requestParameters: DeleteByIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteByIdRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAttachmentByIdRaw(requestParameters: GetAttachmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportResponseDTO>> {
        if (requestParameters['idFileAllegato'] == null) {
            throw new runtime.RequiredError(
                'idFileAllegato',
                'Required parameter "idFileAllegato" was null or undefined when calling getAttachmentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Attachments/{idFileAllegato}`.replace(`{${"idFileAllegato"}}`, encodeURIComponent(String(requestParameters['idFileAllegato']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportResponseDTOFromJSON(jsonValue));
    }

    /**
     */
    async getAttachmentById(requestParameters: GetAttachmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportResponseDTO> {
        const response = await this.getAttachmentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAttachmentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AttachmentResponseDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Attachments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AttachmentResponseDTOFromJSON));
    }

    /**
     */
    async getAttachments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AttachmentResponseDTO>> {
        const response = await this.getAttachmentsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadFileTemporaneoRaw(requestParameters: UploadFileTemporaneoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/api/Attachments/uploadFileTemporaneo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async uploadFileTemporaneo(requestParameters: UploadFileTemporaneoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadFileTemporaneoRaw(requestParameters, initOverrides);
    }

}
